const scrollPartiallyVisibleMenuItemIntoView  = (titleKey: string) => {
    const menuItemsContainer = document.querySelector('.menuItems-disable-scrollbar');
    const selectedItem = menuItemsContainer?.querySelector(`[data-menu-item="${titleKey}"]`);
    
    if (menuItemsContainer && selectedItem) {
        const containerRect = menuItemsContainer.getBoundingClientRect();
        const itemRect = selectedItem.getBoundingClientRect();
        
        const isPartiallyVisible = 
            itemRect.left < containerRect.left || 
            itemRect.right > containerRect.right;
        
        if (isPartiallyVisible) {
            const scrollLeft = itemRect.left - containerRect.left + menuItemsContainer.scrollLeft;
            
            menuItemsContainer.scrollTo({
                left: scrollLeft - 8,
                behavior: 'smooth'
            });
        }
    }
};

export default scrollPartiallyVisibleMenuItemIntoView;